import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-show-more-button',
  templateUrl: './show-more-button.component.html',
  styleUrls: ['./show-more-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
})
export class ShowMoreButtonComponent {
  @Input() parent: ElementRef | undefined;

  isHiddenButton = false;

  showMoreContent(): void {
    if (this.parent) {
      this.parent.nativeElement.style.height = 'auto';
    }
    this.isHiddenButton = true;
  }
}
